import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var BoxSelect = createReactComponent("BoxSelect", ["svg", defaultAttributes, [["path", {
  d: "M4 2a2 2 0 00-2 2",
  key: "1eheh9"
}], ["line", {
  x1: "8",
  y1: "2",
  x2: "10",
  y2: "2",
  key: "ecd3k9"
}], ["line", {
  x1: "14",
  y1: "2",
  x2: "16",
  y2: "2",
  key: "ply5xu"
}], ["path", {
  d: "M4 22a2 2 0 01-2-2",
  key: "wwvhe0"
}], ["line", {
  x1: "22",
  y1: "8",
  x2: "22",
  y2: "10",
  key: "1vwrgu"
}], ["line", {
  x1: "22",
  y1: "14",
  x2: "22",
  y2: "16",
  key: "2fkjma"
}], ["path", {
  d: "M22 20a2 2 0 01-2 2",
  key: "1lm9s5"
}], ["line", {
  x1: "14",
  y1: "22",
  x2: "16",
  y2: "22",
  key: "185ln8"
}], ["line", {
  x1: "8",
  y1: "22",
  x2: "10",
  y2: "22",
  key: "1501e8"
}], ["path", {
  d: "M20 2a2 2 0 012 2",
  key: "8qmqb0"
}], ["line", {
  x1: "2",
  y1: "14",
  x2: "2",
  y2: "16",
  key: "bcn2gi"
}], ["line", {
  x1: "2",
  y1: "8",
  x2: "2",
  y2: "10",
  key: "16xi07"
}]]]);
export default BoxSelect;